import React from "react";
import { Redirect } from "react-router-dom";

//Dashboard
import DashboardAnalytics from "../pages/DashboardAnalytics";
import Users from "../pages/Users";

//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import LogoutSuccess from "../pages/Authentication/LogoutSuccess";
import SignUp from "../pages/Authentication/SignUp";
import ActivateAccount from "../pages/Authentication/ActivateAccount";

// error pages
import NotFoundPage from "../pages/AuthenticationInner/Errors/NotFoundPage";
import ForbiddenPage from "../pages/AuthenticationInner/Errors/ForbiddenPage";
import HubspotCallback from "../pages/Oauth/HubspotCallback";

import Integration from "../pages/Integration";
import Account from "../pages/Account";
import CustomersPage from "../pages/TenantsManagement/CustomersPage";
import TenantDetails from "../pages/TenantDetails";
import SmsHistory from "../pages/SmsHistory/index";
import SmsLogDetail from "../pages/SmsLogs/SmsLogDetail";
import ResetPasswordPage from "../pages/Authentication/ResetPassword";
import SystemTools from "../pages/SystemTools";
import PlanUsage from "../pages/PlanUsage";

//Layouts
import VerticalLayout from "../layouts/index";
import NonAuthLayout from "../layouts/NonAuthLayout";

// Who may open a page (HXSMSF-144). Routes without roles are open to every
// signed-in user; anyone else is sent to /403.
const PLATFORM_ADMINS = ["SUPER_ADMIN", "ADMIN"];
const TENANT_USERS = ["TENANT_ADMIN", "TENANT_USER"];

const authProtectedRoutes = [
  {
    path: "/dashboard",
    component: DashboardAnalytics,
    layout: VerticalLayout,
  },
  {
    path: "/usage",
    exact: true,
    component: () => <Redirect to="/customers" />,
    layout: VerticalLayout,
  },
  {
    path: "/plan-usage",
    component: PlanUsage,
    layout: VerticalLayout,
  },
  {
    path: "/customers/:id",
    component: TenantDetails,
    layout: VerticalLayout,
    roles: PLATFORM_ADMINS,
  },
  {
    path: "/customers",
    component: CustomersPage,
    layout: VerticalLayout,
    roles: PLATFORM_ADMINS,
  },
  { path: "/team", component: Users, layout: VerticalLayout },
  {
    path: "/integration",
    component: Integration,
    layout: VerticalLayout,
    roles: TENANT_USERS,
  },
  {
    path: "/sms-logs/:id",
    component: SmsLogDetail,
    layout: VerticalLayout,
  },
  {
    path: "/sms-logs",
    component: SmsHistory,
    layout: VerticalLayout,
  },
  { path: "/account", component: Account, layout: VerticalLayout },
  {
    path: "/system-tools",
    component: SystemTools,
    layout: VerticalLayout,
    roles: PLATFORM_ADMINS,
  },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/dashboard" />,
    layout: VerticalLayout,
  },

  { path: "*", component: NotFoundPage, layout: NonAuthLayout },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout-success", component: LogoutSuccess },
  { path: "/oauth-callback", component: HubspotCallback },
  // Login - unified endpoint for all users
  { path: "/login", component: Login },

  { path: "/forgot-password", component: ForgetPasswordPage },
  { path: "/reset-password/:token", component: ResetPasswordPage },
  { path: "/reset-password", component: () => <Redirect to="/403" /> },

  // For admin/user activation (invitation flow)
  { path: "/activate/:token", component: ActivateAccount },
  { path: "/activate", component: () => <Redirect to="/403" /> },

  // For client route sign up
  { path: "/sign-up/:token", component: SignUp },
  { path: "/sign-up", component: () => <Redirect to="/403" /> },

  // For team member route sign up
  { path: "/register/:token", component: SignUp },
  { path: "/register", component: () => <Redirect to="/403" /> },

  { path: "/404", component: NotFoundPage },
  { path: "/403", component: ForbiddenPage },
];

export { authProtectedRoutes, publicRoutes };
